"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __jsx = React.createElement;
function SvgComponent(props) {
  return __jsx("svg", (0, _extends2.default)({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), __jsx("g", {
    fill: "none",
    fillRule: "evenodd"
  }, __jsx("path", {
    d: "M-1337-1095H583v4595h-1920z"
  }), __jsx("g", {
    transform: "translate(1 1)",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, __jsx("path", {
    d: "M0 14.348A5.872 5.872 0 018.174 8.95"
  }), __jsx("circle", {
    cx: 5.87,
    cy: 3.587,
    r: 3.587
  }), __jsx("path", {
    d: "M19.565 13.043v5.218c0 .72-.584 1.304-1.304 1.304h-7.826c-.72 0-1.305-.584-1.305-1.304v-5.217"
  }), __jsx("path", {
    d: "M19.565 13.043c0-.72-.584-1.304-1.304-1.304h-7.826c-.72 0-1.305.584-1.305 1.304l4.526 2.828c.423.264.96.264 1.383 0l4.526-2.828z"
  }))));
}
var _default = exports.default = SvgComponent;